import { Newsfeed } from "./newsfeed";
import { CustomParticipant } from "./custom-participant";
import { Participant } from "./participant";
import * as moment from 'moment/moment';

import { NewsfeedCommentTranslation } from "./newsfeed-comment-translation";

import { Translatable } from "./translatable.interface";


export class NewsfeedComment implements Translatable {
    id: number;
    participant_id: number;
    newsfeed_id: number;
    message: string;
    created_at: string;
    date_created_at: Date;
    custom_participant_id: number;
    custom_participant: CustomParticipant = new CustomParticipant;
    participant: Participant = new Participant;

    translations: NewsfeedCommentTranslation[] = [];

    /**
     * constructor
     *
     * @param {NewsfeedComment} init
     */
    public constructor(init?: NewsfeedComment) {
        if (!!init) {
            Object.assign(this, init);
            this.translations = this.translations.map(t => new NewsfeedCommentTranslation(t));

            this.date_created_at = moment.utc(this.created_at).toDate();

            if (init.custom_participant) {
                this.custom_participant = new CustomParticipant(init.custom_participant);
            }
        }
    }

    /**
     * return real participant if possible
     * @return Participant || false
     */
    public getRealParticipant() {
        let participant = null;

        // selected participant by organizer
        if (this.custom_participant) {
            if (this.custom_participant.participant_id) {
                participant = this.custom_participant.participant;
            }
        }

        // normal participant
        else if (this.participant_id) {
            participant = this.participant;
        }

        return participant || false;
    }

    /**
     * get translated attributes
     *
     * @param locale
     *
     * @return {VotingTranslation}
     */
    public translateOrNew(locale: string) {
        let currentTranslation = this.translations.filter(translation => translation.locale === locale)[0];

        if (!currentTranslation) {
            currentTranslation = new NewsfeedCommentTranslation;
            currentTranslation.locale = locale;

            this.translations.push(currentTranslation);
        }

        return currentTranslation;
    }

    /**
     * translate
     *
     * @param locale
     * @param defaultLocale
     * @return {VotingTranslation}
     */
    public translate(locale: string, defaultLocale?: string) {
        let translation = this.translations.filter(translation => { return translation.locale === locale; })[0] ||
            this.translations.filter(translation => { return translation.locale === defaultLocale; })[0] ||
            new NewsfeedCommentTranslation({
                message: this.message
            });
        if (translation) {
            return translation;
        } else {
            return this;
        }
    }
}
